<template>
  <!-- Header-->
  <header id="Startseite" style="height: 65vh">
    <div class="container px-5">
      <div class="row gx-5 align-items-center justify-content-center">
        <div class="col-12">
          <div class="my-5 text-center">
            <!--
            <h1 class="pt-5 text-white" data-aos="fade-up" data-aos-delay="500">DJ Medi</h1>
            <h2 class="text-white mb-0 fs-2" data-aos="fade-up" data-aos-delay="500">Hochzeit &middot; Event &middot; Geburtstag</h2>
            -->
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
</script>

<style scoped>
header {
  padding-top: 150px;
  padding-bottom: 150px;
  background: url('@/assets/img/holzliebe.jpg');
  background-size: cover;
  background-position: bottom;
  background-attachment: fixed;
  position: relative;
}
img {
  max-height: 250px;
  max-width: 100%;
}
</style>